module.exports = __webpack_public_path__ + "117ab5dbf4a333cc9e4a950c7a52661c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SharePopup/mobile_share.svg
// module id = ./src/components/SharePopup/mobile_share.svg
// module chunks = 5